<template>
    <div style="display: flex; flex-direction: column; position: relative;">
        <ModalHeader title="출퇴근" :is-show-back-btn="false" :is_left_area_custom="false" ></ModalHeader>
        <div style="flex:1; display:flex; flex-direction:column;">
            <div style="display: flex; flex-direction: column; gap: 24px; margin-top: 80px; align-items: center;">
                <div :class="is_attend_able ? 'active' : ''" @click="setWorkType(ATTENDANCE.START_WORK)" class="common_btn">출근</div>
                <div :class="is_exit_able ? 'active' : ''" @click="setWorkType(ATTENDANCE.LEAVE_WORK)" class="common_btn" style="margin-top:15px;">퇴근</div>
            </div>
            <div style="flex:1;display:flex; justify-content: center; margin-top:20px;">
                <div style="width:260px;" v-if="work_calendar">
                    <div v-if="work_calendar.begin_date" style="font-size:20px; color:#666666;">출근 : {{work_calendar.begin_date.substr(11, 5)}}</div>
                    <div v-if="work_calendar.end_date" style="font-size:20px; margin-top:5px;color:#666666;">퇴근 : {{work_calendar.end_date.substr(11, 5)}}</div>
                </div>
            </div>
        </div>
        <div>

        </div>
        <div v-if="is_show_not_office_toast" class="popup">
            <div style="display: flex; align-items: center; text-align: center; line-height: 24px; font-size: 18px;">공장 사무실에서만<br>실행 가능합니다.</div>
        </div>
        <div v-if="is_show_not_office_toast" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10;"></div>
        <PageBottom />
    </div>
</template>


<script>
    import PageBottom from "@/components/common/PageBottom";
    import ModalHeader from "@/components/common/ModalHeader";
    import ResponseCode from "../../ResponseCode";

    const ATTENDANCE = {
        START_WORK: 'START_WORK',
        LEAVE_WORK: 'LEAVE_WORK'
    }

    export default {
        name: "Attendance",
        components: {ModalHeader, PageBottom},
        data(){
            return {
                isInOffice: false,
                ATTENDANCE: ATTENDANCE,
                work_calendar : null,
                is_show_not_office_toast : false,
                interval_checkIsOffice : null,
            }
        },
        computed : {
            is_attend_able(){
                return this.isInOffice && this.work_calendar && this.work_calendar.state === '확정' && !this.work_calendar.begin_date;
            },
            is_exit_able(){
                return this.isInOffice && this.work_calendar && this.work_calendar.state === '확정' && this.work_calendar.begin_date && !this.work_calendar.end_date;
            }
        },
        methods : {
            async setWorkType(type) {
                this.is_show_not_office_toast = !this.isInOffice;

                //오피스 안이 아님
                if (this.is_show_not_office_toast) {
                    setTimeout(() => {
                        this.is_show_not_office_toast = false
                    }, 2000);
                    return;
                }

                if(!this.work_calendar) return;

                if(this.is_attend_able && type === ATTENDANCE.START_WORK){
                    this.$GlobalStore.showConfirm('잔업 가능여부', async () => {
                        const parameters = {};
                        parameters.work_calendar_idx = this.work_calendar.idx;
                        const res = await this.$Axios.post('/api/work/attend/check', parameters);
                        if(res.data.code === ResponseCode.SUCCESS){
                            this.$GlobalStore.addModal('Contract', {work_calendar_idx : this.work_calendar.idx, completeAction : async (contract_image_str) => {
                                    await this.attend(contract_image_str, '가능');
                                }
                            });

                        }else if(res.data.code === ResponseCode.FAIL){
                            this.$GlobalStore.showAlert(res.data.msg);
                        }

                    }, '가능', '불가', async () => {
                        const parameters = {};
                        parameters.work_calendar_idx = this.work_calendar.idx;
                        const res = await this.$Axios.post('/api/work/attend/check', parameters);
                        if(res.data.code === ResponseCode.SUCCESS){
                            this.$GlobalStore.addModal('Contract', {work_calendar_idx : this.work_calendar.idx, completeAction : async (contract_image_str) => {
                                    await this.attend(contract_image_str, '불가');
                                }
                            });

                        }else if(res.data.code === ResponseCode.FAIL){
                            this.$GlobalStore.showAlert(res.data.msg);
                        }
                    })
                }else if(this.is_exit_able && type === ATTENDANCE.LEAVE_WORK){
                    this.$GlobalStore.showConfirm('퇴근 처리 하시겠습니까?', async () => {
                        await this.exit();
                    }, '확인', '닫기', async () => {

                    })

                }
            },
            async getTodayWork(){
                const res = await this.$Axios.get('/api/work/today');
                this.work_calendar = res.data.work_calendar;
            },
            async attend(contract_image_str, overwork){
                const parameters = {};
                parameters.work_calendar_idx = this.work_calendar.idx;
                parameters.contract_image_str = contract_image_str;
                parameters.overwork = overwork;
                const res = await this.$Axios.post('/api/work/attend', parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.getTodayWork();
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async exit(){
                const parameters = {};
                parameters.work_calendar_idx = this.work_calendar.idx;
                const res = await this.$Axios.post('/api/work/exit', parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.getTodayWork();
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            checkIsOffice(is_permission_check = false){
                let next_state = false;

                const device = this.$cookies.get('device')
                if(device === 'android'){
                    if(is_permission_check) window.Android.checkPermission();

                    const beacon_str = window.Android.getBeaconData();

                    const beacons = JSON.parse(beacon_str);
                    if(beacons.length > 0){
                        for(const each of beacons){
                            if(each.major == '10001' && each.minor == '19641' && each.distance <= 10.0){
                                next_state = true;
                                break;
                            }
                        }
                    }

                    this.isInOffice = next_state

                } else if(device === 'ios'){
                    window.setBeaconData = (beacon_str) => {
                        const beacons = JSON.parse(beacon_str);
                        if(beacons.length > 0){
                            for(const each of beacons){
                                if(each.major == '10001' && each.minor == '19641' && each.distance <= 10.0){
                                    next_state = true;
                                    break;
                                }
                            }
                        }

                        this.isInOffice = next_state
                    }

                    /*eslint-disable no-undef */
                    webkit.messageHandlers.ios.postMessage({ cmd: 'getBeaconData'});
                }

                // this.isInOffice = true;
            }
        },
        deactivated(){
            if(this.interval_checkIsOffice) clearInterval(this.interval_checkIsOffice);
        },
        created(){
            this.attend = this.$Once(this.attend);
            this.exit = this.$Once(this.exit);

            this.getTodayWork();
            this.checkIsOffice(true);
            this.interval_checkIsOffice = setInterval(() => {
                this.checkIsOffice(false);
            }, 5000);
        }

    }
</script>

<style scoped>
.common_btn {
    display:flex;
    align-items: center; 
    padding:16px 16px;
    border-radius: 12px; 
    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.4);
    width: 260px;
    justify-content: center;
    height: 140px;
    font-size: 40px;
    color: var(--color-main);
    font-weight:bold;

}

.active {
    background-color: var(--color-main);
    color: #fff;
}

.popup {
    position: absolute; 
    left: 50%; 
    top: 240px; 
    transform: translateX(-50%); 
    width: 260px;
    background-color: #fff; 
    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);
    height: 100px;
    display: flex;
    justify-content: center;
    align-content: center;
    border-radius: 12px;
    color: var(--color-main);
    font-weight: 500;
    z-index: 20;
}
</style>